export const FORTUNE_ACTIONS = {
  POST_QUIZ_DATA: 'postQuizData',
  GET_CHANNEL_DATA: 'getChannelData',
  GET_COUNT: 'getCount',
  GET_RESULT: 'getResult',
  GET_SIMPLE_RESULT: 'getSimpleResult',
  GET_HISTORY: 'getHistory',
}
